module.exports = __webpack_public_path__ + "img/al.ce5c8b83.png";